/**
 * 游客账号管理
 * 页面加载时自动创建或获取游客账号
 */

(function () {
  "use strict";

  // 配置
  const GUEST_CONFIG = {
    baseUrl: "https://clb.zmkj.site:3000",
    storageKey: "deliver3d_guest_token",
  };

  // 游客账号对象
  const GuestAccount = {
    // 初始化
    async init() {
      console.log("[Guest Account] Initializing...");

      try {
        // 检查是否已有有效的token
        const existingToken = this.getStoredToken();

        if (existingToken) {
          console.log("[Guest Account] Using existing token");
          window.guestToken = existingToken;
          return { token: existingToken };
        }

        // 创建新的游客账号
        console.log("[Guest Account] Creating new tourist account...");
        const token = await this.createTourist();

        if (token) {
          console.log("[Guest Account] Tourist account created successfully");
          window.guestToken = token;
          return { token };
        }
      } catch (error) {
        console.error("[Guest Account] Initialization failed:", error);
        return null;
      }
    },

    // 创建游客账号（按照你的项目逻辑）
    async createTourist() {
      try {
        // 步骤1: 获取临时用户信息
        const tempUserInfo = await this.getTouristToken();
        const { username, password, nickname } = tempUserInfo;

        console.log("[Guest Account] Got temp user info:", {
          username,
          nickname,
        });

        // 步骤2: 注册用户
        await this.register({
          username,
          password,
          displayName: nickname,
          isTemp: 1,
          isDeliver3D: 1,
        });

        console.log("[Guest Account] User registered");

        // 步骤3: 登录获取token
        const loginResult = await this.login(username, password);
        const token = loginResult.token || loginResult.accessToken;
        this.storeToken(token);
        if (!token) {
          throw new Error("No token received from login");
        }

        // 步骤4: 设置月度积分
        try {
          await this.setMonthlyPointsForLoginFirst({ mode: "anonymous" });
          console.log("[Guest Account] Monthly points set");
        } catch (err) {
          console.warn("[Guest Account] Failed to set monthly points:", err);
          // 不阻断流程，继续执行
        }

        return token;
      } catch (error) {
        console.error("[Guest Account] Failed to create tourist:", error);
        throw error;
      }
    },

    // API: 获取临时用户信息
    async getTouristToken() {
      const response = await fetch(
        `${GUEST_CONFIG.baseUrl}/auth/tempUserInfo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Get tourist token failed: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },

    // API: 注册用户
    async register(data) {
      const response = await fetch(`${GUEST_CONFIG.baseUrl}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Register failed: ${response.statusText}`);
      }

      return await response.json();
    },

    // API: 登录
    async login(username, password) {
      const response = await fetch(`${GUEST_CONFIG.baseUrl}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password, isDeliver3D: 1 }),
      });

      if (!response.ok) {
        throw new Error(`Login failed: ${response.statusText}`);
      }

      return await response.json();
    },

    // API: 设置月度积分
    async setMonthlyPointsForLoginFirst(data = {}) {
      const response = await fetch(
        `${GUEST_CONFIG.baseUrl}/member/setMonthlyPointsForLoginFirst`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getStoredToken()}`,
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error(`Set monthly points failed: ${response.statusText}`);
      }

      return await response.json();
    },

    // 从本地存储获取token
    getStoredToken() {
      try {
        return localStorage.getItem(GUEST_CONFIG.storageKey);
      } catch (error) {
        console.error("[Guest Account] Failed to get stored token:", error);
        return null;
      }
    },

    // 存储token到本地
    storeToken(token) {
      try {
        localStorage.setItem(GUEST_CONFIG.storageKey, token);
      } catch (error) {
        console.error("[Guest Account] Failed to store token:", error);
      }
    },

    // 清除账号
    clearAccount() {
      try {
        localStorage.removeItem(GUEST_CONFIG.storageKey);
        delete window.guestToken;
        console.log("[Guest Account] Account cleared");
      } catch (error) {
        console.error("[Guest Account] Failed to clear account:", error);
      }
    },

    // 获取Token
    getToken() {
      return window.guestToken || this.getStoredToken();
    },
  };

  // 页面加载完成后立即初始化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      GuestAccount.init();
    });
  } else {
    // DOM 已经加载完成
    GuestAccount.init();
  }

  // 暴露到全局作用域
  window.GuestAccount = GuestAccount;

  // 用于调试
  console.log("[Guest Account] Module loaded");
})();
